import React, { useState } from 'react';
import { Info, X } from 'lucide-react';
import Modal from '@/components/common/Modal/Modal';
import styles from './AffiliateRules.module.css';

/**
 * AffiliateRules Component
 * Displays commission rates, reward rules, and VIP level unlock table
 */
const AffiliateRules = () => {
  const [rulesModal, setRulesModal] = useState(false);

  const VIPLevelData = [
    {
      id: 1,
      level: 'VIP 04',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAwFBMVEUAAADnmTLNdgrdmyvnmTDomTHnmTHnmTHnlzDQehDnmjHMdQvnmTLnmzTKdQvMdQrMdgrMdArnmjLomTLLdArLdAnNdQvPeAj6qT3/uVzMdQr2zjf/4GnnmTHrnTXuoj3/vl7yojjpmzP+uFr9tVb5sTz3pjv/22f/12b2rUv5rDz2yTjunzX/wl782ln5sVH9tE3zqUb300T7rEPjlSzhkSnVghfRfBH+3WP/yGH6zU38r0n4tT33ujrdiyPdiyK4SHOlAAAAGHRSTlMAgN8QYO/ffyDfv79wQDDvz6Cfj4BwYCACrNBxAAAA8klEQVQoz5XRx5LCMAwGYFIJbXtxYuQQp7CBwMLStgHv/1bIwcQxOfFfpPk0o4PUUrE81StsO9BuqO2wPGeureGgy5ex7/tLcAcVel0IEUWSEJ68y9LwU1A1eLaQDZA4Gp1rzvuCQ6njcenJihk1/hgO0eM/QhTPEEV+/0mdf0qcU7pXLFfMvyidEp1n34iUpjrHC7QGLwjBBVNKJ4pZssI+RZmkpOI+RERLBHZ5U5dHNeSOLT9gAM/OmDEwrOq0nQMUGWIBx05LxQx2Gygi2OwCU+Mg2K7XWyw6yzS59/rWu+b7lztR3x/NhxpbqsXxzTkB6pAmmuZQUCUAAAAASUVORK5CYII=',
      wagerValue: '1000',
      rewardAmount: '$0.50',
    },
    {
      id: 2,
      level: 'VIP 08',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAwFBMVEUAAADnmTLNdgrdmyvnmTDomTHnmTHnmTHnlzDQehDnmjHMdQvnmTLnmzTKdQvMdQrMdgrMdArnmjLomTLLdArLdAnNdQvPeAj6qT3/uVzMdQr2zjf/4GnnmTHrnTXuoj3/vl7yojjpmzP+uFr9tVb5sTz3pjv/22f/12b2rUv5rDz2yTjunzX/wl782ln5sVH9tE3zqUb300T7rEPjlSzhkSnVghfRfBH+3WP/yGH6zU38r0n4tT33ujrdiyPdiyK4SHOlAAAAGHRSTlMAgN8QYO/ffyDfv79wQDDvz6Cfj4BwYCACrNBxAAAA8klEQVQoz5XRx5LCMAwGYFIJbXtxYuQQp7CBwMLStgHv/1bIwcQxOfFfpPk0o4PUUrE81StsO9BuqO2wPGeureGgy5ex7/tLcAcVel0IEUWSEJ68y9LwU1A1eLaQDZA4Gp1rzvuCQ6njcenJihk1/hgO0eM/QhTPEEV+/0mdf0qcU7pXLFfMvyidEp1n34iUpjrHC7QGLwjBBVNKJ4pZssI+RZmkpOI+RERLBHZ5U5dHNeSOLT9gAM/OmDEwrOq0nQMUGWIBx05LxQx2Gygi2OwCU+Mg2K7XWyw6yzS59/rWu+b7lztR3x/NhxpbqsXxzTkB6pAmmuZQUCUAAAAASUVORK5CYII=',
      wagerValue: '5000',
      rewardAmount: '$2.50',
    },
    {
      id: 3,
      level: 'VIP 14',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAwFBMVEUAAADnmTLNdgrdmyvnmTDomTHnmTHnmTHnlzDQehDnmjHMdQvnmTLnmzTKdQvMdQrMdgrMdArnmjLomTLLdArLdAnNdQvPeAj6qT3/uVzMdQr2zjf/4GnnmTHrnTXuoj3/vl7yojjpmzP+uFr9tVb5sTz3pjv/22f/12b2rUv5rDz2yTjunzX/wl782ln5sVH9tE3zqUb300T7rEPjlSzhkSnVghfRfBH+3WP/yGH6zU38r0n4tT33ujrdiyPdiyK4SHOlAAAAGHRSTlMAgN8QYO/ffyDfv79wQDDvz6Cfj4BwYCACrNBxAAAA8klEQVQoz5XRx5LCMAwGYFIJbXtxYuQQp7CBwMLStgHv/1bIwcQxOfFfpPk0o4PUUrE81StsO9BuqO2wPGeureGgy5ex7/tLcAcVel0IEUWSEJ68y9LwU1A1eLaQDZA4Gp1rzvuCQ6njcenJihk1/hgO0eM/QhTPEEV+/0mdf0qcU7pXLFfMvyidEp1n34iUpjrHC7QGLwjBBVNKJ4pZssI+RZmkpOI+RERLBHZ5U5dHNeSOLT9gAM/OmDEwrOq0nQMUGWIBx05LxQx2Gygi2OwCU+Mg2K7XWyw6yzS59/rWu+b7lztR3x/NhxpbqsXxzTkB6pAmmuZQUCUAAAAASUVORK5CYII=',
      wagerValue: '17000',
      rewardAmount: '$5.00',
    },
    {
      id: 4,
      level: 'VIP 22',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAwFBMVEUAAADnmTLNdgrdmyvnmTDomTHnmTHnmTHnlzDQehDnmjHMdQvnmTLnmzTKdQvMdQrMdgrMdArnmjLomTLLdArLdAnNdQvPeAj6qT3/uVzMdQr2zjf/4GnnmTHrnTXuoj3/vl7yojjpmzP+uFr9tVb5sTz3pjv/22f/12b2rUv5rDz2yTjunzX/wl782ln5sVH9tE3zqUb300T7rEPjlSzhkSnVghfRfBH+3WP/yGH6zU38r0n4tT33ujrdiyPdiyK4SHOlAAAAGHRSTlMAgN8QYO/ffyDfv79wQDDvz6Cfj4BwYCACrNBxAAAA8klEQVQoz5XRx5LCMAwGYFIJbXtxYuQQp7CBwMLStgHv/1bIwcQxOfFfpPk0o4PUUrE81StsO9BuqO2wPGeureGgy5ex7/tLcAcVel0IEUWSEJ68y9LwU1A1eLaQDZA4Gp1rzvuCQ6njcenJihk1/hgO0eM/QhTPEEV+/0mdf0qcU7pXLFfMvyidEp1n34iUpjrHC7QGLwjBBVNKJ4pZssI+RZmkpOI+RERLBHZ5U5dHNeSOLT9gAM/OmDEwrOq0nQMUGWIBx05LxQx2Gygi2OwCU+Mg2K7XWyw6yzS59/rWu+b7lztR3x/NhxpbqsXxzTkB6pAmmuZQUCUAAAAASUVORK5CYII=',
      wagerValue: '49000',
      rewardAmount: '$12.00',
    },
    {
      id: 5,
      level: 'VIP 30',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAwFBMVEUAAADnmTLNdgrdmyvnmTDomTHnmTHnmTHnlzDQehDnmjHMdQvnmTLnmzTKdQvMdQrMdgrMdArnmjLomTLLdArLdAnNdQvPeAj6qT3/uVzMdQr2zjf/4GnnmTHrnTXuoj3/vl7yojjpmzP+uFr9tVb5sTz3pjv/22f/12b2rUv5rDz2yTjunzX/wl782ln5sVH9tE3zqUb300T7rEPjlSzhkSnVghfRfBH+3WP/yGH6zU38r0n4tT33ujrdiyPdiyK4SHOlAAAAGHRSTlMAgN8QYO/ffyDfv79wQDDvz6Cfj4BwYCACrNBxAAAA8klEQVQoz5XRx5LCMAwGYFIJbXtxYuQQp7CBwMLStgHv/1bIwcQxOfFfpPk0o4PUUrE81StsO9BuqO2wPGeureGgy5ex7/tLcAcVel0IEUWSEJ68y9LwU1A1eLaQDZA4Gp1rzvuCQ6njcenJihk1/hgO0eM/QhTPEEV+/0mdf0qcU7pXLFfMvyidEp1n34iUpjrHC7QGLwjBBVNKJ4pZssI+RZmkpOI+RERLBHZ5U5dHNeSOLT9gAM/OmDEwrOq0nQMUGWIBx05LxQx2Gygi2OwCU+Mg2K7XWyw6yzS59/rWu+b7lztR3x/NhxpbqsXxzTkB6pAmmuZQUCUAAAAASUVORK5CYII=',
      wagerValue: '129000',
      rewardAmount: '$25.00',
    },
    {
      id: 6,
      level: 'VIP 38',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAmVBMVEUAAACLUvpoI9GLSfmNUfmNUfmNUfmPUPduKdeMUfpoJNKLUviLVPtnJc9nI9FnItFoI9GNUvqNUvpoJM9mJM9oI89oIM+MUfl/M/FoI9FxWv+ygP2JSveFQPWANvOsev2RV/mKTviHRvZ8O/WDY/+pdf1zVf2COvNzMt6UW/p6QveHTPSER/B/QOqZcv6hd/2aY/uISPZtKdZNYj5JAAAAF3RSTlMAgN8QYO/fIN+/v3BAMO/PoJ+PgHBgIO9EidIAAADVSURBVCjPldHXEoMgEAVQscT0noDEhjGWqGn//3FZyCCgT7kPspydWRmwVBxf1QqRh9FIXQ9DJq6ByxlH0Vj26AOq7Px+qJm9A4zkLk1ltdA4TRLhYRkijW+XC/eIEMU1ICTJ70Tnl9AHpYrliGdOaUFMrpOcQq4DzsBGnMUEBhSUxhqHfHMl4tPzAo6qJ46wK+50wrRGxDxXvgBm5Q/LkCHHkpl2/K8kfuNuaqnYwafFWcTaKrANDoKqaSpYTJYZ8fx4mg95fVjx9by1Nxo7qoT23/kCzuoiAL1lpEQAAAAASUVORK5CYII=',
      wagerValue: '321000',
      rewardAmount: '$50.00',
    },
    {
      id: 7,
      level: 'VIP 46',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAmVBMVEUAAACLUvpoI9GLSfmNUfmNUfmNUfmPUPduKdeMUfpoJNKLUviLVPtnJc9nI9FnItFoI9GNUvqNUvpoJM9mJM9oI89oIM+MUfl/M/FoI9FxWv+ygP2JSveFQPWANvOsev2RV/mKTviHRvZ8O/WDY/+pdf1zVf2COvNzMt6UW/p6QveHTPSER/B/QOqZcv6hd/2aY/uISPZtKdZNYj5JAAAAF3RSTlMAgN8QYO/fIN+/v3BAMO/PoJ+PgHBgIO9EidIAAADVSURBVCjPldHXEoMgEAVQscT0noDEhjGWqGn//3FZyCCgT7kPspydWRmwVBxf1QqRh9FIXQ9DJq6ByxlH0Vj26AOq7Px+qJm9A4zkLk1ltdA4TRLhYRkijW+XC/eIEMU1ICTJ70Tnl9AHpYrliGdOaUFMrpOcQq4DzsBGnMUEBhSUxhqHfHMl4tPzAo6qJ46wK+50wrRGxDxXvgBm5Q/LkCHHkpl2/K8kfuNuaqnYwafFWcTaKrANDoKqaSpYTJYZ8fx4mg95fVjx9by1Nxo7qoT23/kCzuoiAL1lpEQAAAAASUVORK5CYII=',
      wagerValue: '769000',
      rewardAmount: '$80.00',
    },
    {
      id: 8,
      level: 'VIP 54',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAmVBMVEUAAACLUvpoI9GLSfmNUfmNUfmNUfmPUPduKdeMUfpoJNKLUviLVPtnJc9nI9FnItFoI9GNUvqNUvpoJM9mJM9oI89oIM+MUfl/M/FoI9FxWv+ygP2JSveFQPWANvOsev2RV/mKTviHRvZ8O/WDY/+pdf1zVf2COvNzMt6UW/p6QveHTPSER/B/QOqZcv6hd/2aY/uISPZtKdZNYj5JAAAAF3RSTlMAgN8QYO/fIN+/v3BAMO/PoJ+PgHBgIO9EidIAAADVSURBVCjPldHXEoMgEAVQscT0noDEhjGWqGn//3FZyCCgT7kPspydWRmwVBxf1QqRh9FIXQ9DJq6ByxlH0Vj26AOq7Px+qJm9A4zkLk1ltdA4TRLhYRkijW+XC/eIEMU1ICTJ70Tnl9AHpYrliGdOaUFMrpOcQq4DzsBGnMUEBhSUxhqHfHMl4tPzAo6qJ46wK+50wrRGxDxXvgBm5Q/LkCHHkpl2/K8kfuNuaqnYwafFWcTaKrANDoKqaSpYTJYZ8fx4mg95fVjx9by1Nxo7qoT23/kCzuoiAL1lpEQAAAAASUVORK5CYII=',
      wagerValue: '1793000',
      rewardAmount: '$120.00',
    },
    {
      id: 9,
      level: 'VIP 62',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAmVBMVEUAAACLUvpoI9GLSfmNUfmNUfmNUfmPUPduKdeMUfpoJNKLUviLVPtnJc9nI9FnItFoI9GNUvqNUvpoJM9mJM9oI89oIM+MUfl/M/FoI9FxWv+ygP2JSveFQPWANvOsev2RV/mKTviHRvZ8O/WDY/+pdf1zVf2COvNzMt6UW/p6QveHTPSER/B/QOqZcv6hd/2aY/uISPZtKdZNYj5JAAAAF3RSTlMAgN8QYO/fIN+/v3BAMO/PoJ+PgHBgIO9EidIAAADVSURBVCjPldHXEoMgEAVQscT0noDEhjGWqGn//3FZyCCgT7kPspydWRmwVBxf1QqRh9FIXQ9DJq6ByxlH0Vj26AOq7Px+qJm9A4zkLk1ltdA4TRLhYRkijW+XC/eIEMU1ICTJ70Tnl9AHpYrliGdOaUFMrpOcQq4DzsBGnMUEBhSUxhqHfHMl4tPzAo6qJ46wK+50wrRGxDxXvgBm5Q/LkCHHkpl2/K8kfuNuaqnYwafFWcTaKrANDoKqaSpYTJYZ8fx4mg95fVjx9by1Nxo7qoT23/kCzuoiAL1lpEQAAAAASUVORK5CYII=',
      wagerValue: '4097000',
      rewardAmount: '$205.00',
    },
    {
      id: 10,
      level: 'VIP 70',
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAMAAABS8b9vAAAAnFBMVEUAAAD2Uvq5I9HwSfn0Ufn1Ufn3UPf1Ufn2Ufq6JNL3VPu6Jc+6I9H2UfnBKtfBKda6ItG5I9H1Uvr2Uvq3JM/2Uvj0Uvi4JM+3I8+3IM/1UfnWM/G5I9H/Wu79gOLtSvf2V/beO/H9eeXbN/LxTfjmQvbzT/jqRvbiPvTnQ/D5Ve/8c+jqSPL6Yu//ZOvfQOrKMNz3XfPPNeDBKdY/QCCmAAAAGnRSTlMAgN8QYO8g37+/QDDv39/fz6Cfj4BwcHBgIHcu2AoAAADSSURBVCjPldHJFoIgFIBhcapsngtEnGfT6v3frSsdRHLVvxD44LAQTWbYci4RWRhN1LQwNDMVdOZgvJkzoA0oO9jDpWpHAxiJle+L2XnEfhhyZwFDA4N6HniaEyLZrzxeU5AxNxwrSlXGcDp8UFoSlZ+AUKByWoNNOCEELigpjUbM+kVA+GfgC5xVSrDJ/+k6ziXmsWWKF8Bx9MWAxcjQRNsWZ7ARZbjdaDLdfdc4S9Kic3WFXffFWAeDyqIJL663xS+vTst+vO/13YgNOYXtv/sAyBklnX1oiAMAAAAASUVORK5CYII=',
      wagerValue: '9217000',
      rewardAmount: '$500.00',
    },
  ];

  return (
    <div className={styles.body}>
      {/* Commission Reward Rate Section */}
      <div className={styles.sectionWrapper}>
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionTitle}>Commission Reward Rate</h3>
          <button
            className={styles.viewRulesButton}
            onClick={() => setRulesModal(true)}
          >
            View Rules
          </button>
        </div>

        <div className={styles.commissionContainer}>
          <div className={styles.commissionBox}>
            <div className={styles.commissionLabel}>The Original Games</div>
            <div className={styles.commissionDetails}>
              Wager x 1% x Commission Rate x 25%
            </div>
          </div>
          <div className={styles.commissionBox}>
            <div className={styles.commissionLabel}>3rd Party Slots and Casino Games</div>
            <div className={styles.commissionDetails}>
              Wager × 1% × Commission Rate × 60%
            </div>
          </div>
        </div>
      </div>

      {/* How to Get Referral Rewards Section */}
      <div className={styles.sectionWrapper}>
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionTitle}>How to Get the Referral Rewards</h3>
        </div>

        <div className={styles.stepContainer}>
          <div className={styles.stepBox}>
            <div className={styles.stepNumber}>1</div>
            <div className={styles.stepContent}>
              <div className={styles.stepTextWrapper}>
                <span className={styles.stepText}>Share</span> to Friends
              </div>
              <div className={styles.stepDescription}>
                Share your referral link or code to your friends
              </div>
            </div>
          </div>

          <div className={styles.stepBox}>
            <div className={styles.stepNumber}>2</div>
            <div className={styles.stepContent}>
              <div className={styles.stepTextWrapper}>
                Get <span className={styles.stepText}>$1000</span>
              </div>
              <div className={styles.stepDescription}>
                Your awards will be locked for now
              </div>
            </div>
          </div>

          <div className={styles.stepBox}>
            <div className={styles.stepNumber}>3</div>
            <div className={styles.stepContent}>
              <div className={styles.stepTextWrapper}>
                Level Up & <span className={styles.stepText}>Receive</span>
              </div>
              <div className={styles.stepDescription}>
                Your friend's VIP level will unlock your awards (see rules below)
              </div>
            </div>
          </div>
        </div>

        {/* Rewards Table */}
        <div className={styles.rewardsTableWrapper}>
          <table className={styles.rewardsTable}>
            <thead>
              <tr>
                <th>Friend's Level</th>
                <th style={{ textAlign: 'center' }}>Total Wager</th>
                <th style={{ textAlign: 'right' }}>Unlock Amount</th>
              </tr>
            </thead>
            <tbody>
              {VIPLevelData.map((item) => (
                <tr key={item.id}>
                  <td className={styles.levelCell}>
                    <img src={item.icon} alt="VIP Level" />
                    {item.level}
                  </td>
                  <td style={{ textAlign: 'center' }}>{item.wagerValue}</td>
                  <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                    {item.rewardAmount}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Rules Modal */}
      <Modal
        isOpen={rulesModal}
        onClose={() => setRulesModal(false)}
        title="Rules"
        size="md"
      >
        <div className={styles.modalBody}>
          <ul className={styles.infoList}>
            <li>
              In any public environment (eg, universities, schools, libraries, and office spaces), only one commission can be paid to each user, IP address, electronic device, home, phone number, billing method, email address, and computer and IP address shared with others.
            </li>
            <li>
              Our decision to draw a bet will be based entirely on our discretion after a deposit is made and a bet is successfully placed.
            </li>
            <li>
              We support the majority of currencies on the market. Commissions can be withdrawn into our internal Jackopot wallet at anytime. (View your commission extraction in the dashboard and view the balance in the wallet).
            </li>
            <li>
              The system calculates the commission every 24 hours.
            </li>
          </ul>
        </div>
      </Modal>
    </div>
  );
};

export default AffiliateRules;
